module.exports = __webpack_public_path__ + "static/ml_primer_img.1cec936b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/ml_primer_img.png
// module id = 696
// module chunks = 19843951674672